"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("@emotion/react");
const format_1 = require("src/utils/format");
// eslint-disable-next-line complexity
function compileUnderlayStyleString(underlay = {}) {
    const { transparency = 0, color: underlayColorRaw = [255, 255, 255], bgCustom, height, mobile: { padding } = {} } = underlay;
    const underlayAlpha = 1 - transparency / 100;
    const [ucr = 255, ucg = 255, ucb = 255] = Array.isArray(underlayColorRaw)
        ? underlayColorRaw
        : (0, format_1.hexToRgb)(underlayColorRaw);
    return `{
        --page-bg: ${bgCustom ? bgCustom : `rgba(${ucr}, ${ucg}, ${ucb}, ${underlayAlpha})`};
        ${height ? `--page-height: ${height};` : ''}
        ${padding ? `--page-padding-mobile: ${padding};` : ''}

        ${transparency ?
        `
        .page .question-table-scale > .question-table-scale__columns-header-wrapper,
        .page .question-table > .question-table__columns-header,
        .question-table__image-container.question-table__column-image,
        .question-table__image-container.question-table__row-image {
            background: none;
            backdrop-filter: blur(16px);
            -webkit-backdrop-filter: blur(16px);
        }` : ''}
    }`;
}
function brandingUnderlayStyles(branding = {}) {
    const { underlay, darkTheme } = branding;
    const lightThemeString = compileUnderlayStyleString(underlay);
    if (darkTheme === null || darkTheme === void 0 ? void 0 : darkTheme.underlay) {
        const darkThemeString = compileUnderlayStyleString(Object.assign(Object.assign({}, underlay), darkTheme.underlay));
        return (0, react_1.css) `
            :root ${lightThemeString}

            .pythia-surveys-root[data-theme='light'] ${lightThemeString}
            .pythia-surveys-root[data-theme='dark'] ${darkThemeString}
        `;
    }
    return (0, react_1.css) `
        :root ${lightThemeString}

        .pythia-surveys-root[data-theme='light'] ${lightThemeString}
    `;
}
exports.default = brandingUnderlayStyles;
